/**
 * 强制修改密码状态工具
 *
 * 统一封装 force_update_password 在 localStorage 中的读写，避免各处直接比较时
 * 受到 localStorageUtil.getItem 自动 JSON.parse 的影响（例如 '0' 读取后可能变成数字 0）。
 */

import { getItem, setItem, removeItem } from './localStorageUtil';
import { LOCAL_STORAGE_KEYS } from '../const/localStorageConst';

/** 获取当前强制修改密码标记，统一转为字符串 */
export function getForceUpdatePasswordValue() {
  const value = getItem(LOCAL_STORAGE_KEYS.FORCE_UPDATE_PASSWORD);
  return value === null || value === undefined ? null : String(value);
}

/** 是否必须强制修改密码：后端约定 '0' 表示必须修改 */
export function isForceUpdatePasswordRequired() {
  return getForceUpdatePasswordValue() === '0';
}

/** 写入强制修改密码标记，按后端约定存储字符串值 */
export function setForceUpdatePassword(value) {
  setItem(LOCAL_STORAGE_KEYS.FORCE_UPDATE_PASSWORD, String(value));
}

/** 清理强制修改密码标记，用于退出登录或 token 失效 */
export function clearForceUpdatePassword() {
  removeItem(LOCAL_STORAGE_KEYS.FORCE_UPDATE_PASSWORD);
}
